import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from 'immer';
import { initializeUseCase } from "../../logic/initializeQr.case";
import { pollSbpStatusUseCase } from "./pollSbpStatus.case";

// Returns props for rendering QR code view in SBP modal
export var getQRProps = function getQRProps(_ref) {
  var getContent = _ref.getContent,
    getQRCode = _ref.getQRCode,
    initializeQRCode = _ref.initializeQRCode,
    pollSbpStatus = _ref.pollSbpStatus;
  return function (getState, setState) {
    var state = getState();
    var content = getContent();
    var init = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return initializeUseCase({
                initializeQRCode: initializeQRCode
              })(state, setState);
            case 2:
              _context.next = 4;
              return pollSbpStatusUseCase({
                pollSbpStatus: pollSbpStatus
              })(getState, setState);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function init() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      type: 'qr',
      buttonText: content.sbpPopup.qr.buttonText,
      onMount: function onMount() {
        init().catch(console.error);
      },
      onClose: function onClose() {
        setState(produce(function (draft) {
          draft.scenario = undefined;
        }));
      },
      qr: {
        alt: content.sbpPopup.qr.buttonText,
        url: getQRCode()
      },
      subtitle: '',
      sum: state.sumInput.value,
      title: content.sbpPopup.qr.title,
      description: content.sbpPopup.qr.subtitle
    };
  };
};